var React = require('react');

function QuoteInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M118.029 210.012C177.295 210.012 225.34 258.015 225.34 317.227C225.34 376.44 177.295 424.443 118.029 424.443C58.7635 424.443 10.7191 376.44 10.7191 317.227L10.24 301.911C10.24 183.484 106.329 87.48 224.861 87.48V148.746C183.913 148.746 145.416 164.678 116.461 193.607C110.888 199.176 105.801 205.102 101.212 211.326C106.692 210.465 112.308 210.012 118.029 210.012ZM393.971 210.012C453.236 210.012 501.281 258.015 501.281 317.227C501.281 376.44 453.236 424.443 393.971 424.443C334.705 424.443 286.66 376.44 286.66 317.227L286.181 301.911C286.181 183.484 382.269 87.48 500.802 87.48V148.746C459.855 148.746 421.356 164.678 392.402 193.607C386.828 199.176 381.741 205.102 377.153 211.326C382.632 210.465 388.248 210.012 393.971 210.012Z","strokeWidth":"10"}));
}

QuoteInline.defaultProps = {"viewBox":"0 0 512 512","fill":"none"};

module.exports = QuoteInline;

QuoteInline.default = QuoteInline;
